import { setCookie, getCookie } from 'tiny-cookie'
const REFERRAL_KEY = 'pt_referral'

export default {
  current() {
    return getCookie(REFERRAL_KEY)
  },
  set(value) {
    return setCookie(REFERRAL_KEY, value, {
      expires: 60,
      domain: window.location.hostname,
      secure: window.location.protocol === 'https:'
    })
  }
}
